import { Group } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useState } from "react";
import { User } from "../../../../app/backendTypes";
import PolarisGroupsDialog from "./PolarisGroupsDialog";

function PolarisGroupsAction(props: { user: User }) {
  const { user } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Chip
        icon={<Group />}
        variant="outlined"
        color="secondary"
        label="Groups"
        onClick={() => setOpen(true)}
      />
      <PolarisGroupsDialog open={open} setOpen={setOpen} user={user} />
    </>
  );
}

export default PolarisGroupsAction;
